// =========================================================================
// Text from outside, made safe to show a person.
//
// A transaction, an intent file or a node's answer can carry characters that
// a terminal or a screen acts on rather than shows: escape sequences that
// clear the screen and move the cursor, and Unicode controls that reorder the
// text around them. Shown raw, a file's own "txID" printed a forged
// "✓ Matches intent" over the ceremony tool's real verdict (review of
// 3 October 2026). Every such character is shown as its \uXXXX escape instead,
// so what reaches the screen is only what was written.
// =========================================================================

// C0 and C1 controls, DEL, and the characters that change text direction.
const UNPRINTABLE = /[\u0000-\u001f\u007f-\u009f؜‎‏‪-‮⁦-⁩]/g;

export function printable(text) {
  return String(text).replace(UNPRINTABLE, (c) => `\\u${c.charCodeAt(0).toString(16).padStart(4, '0')}`);
}
